import { APISettings } from '../config.js';
export default {
    name: "productsMethods",

    async loadProducts() {
        const response = await fetch(APISettings.baseURL + "loggiaColors/v1/products", {
            mode: 'cors',
            method: 'GET',
        });
        const result = await response.json();

        if(localStorage.getItem("products")){
            let filter = JSON.parse(localStorage.getItem("products")).map(str => {
                return parseInt(str, 10);
              });
            let filtered = [];  
            result.forEach(element=>{
                if(filter.includes(parseInt(element.id))){
                    // console.log("aggiungo id "+element.id);
                    filtered.push(element);
                }
            })
            return filtered;

        }
        return result;
    },

    async loadProductsByColor(data) {
        const response = await fetch(APISettings.baseURL + "loggiaColors/v1/products/colors/" + data, {
            mode: 'cors',
            method: 'GET',
        });
        const result = await response.json();
        if(localStorage.getItem("products")){
            let filter = JSON.parse(localStorage.getItem("products")).map(str => {
                return parseInt(str, 10);
              });
            let filtered = [];  
            result.forEach(element=>{
                if(filter.includes(parseInt(element.id))){
                    // console.log("aggiungo id "+element.id);
                    filtered.push(element);
                }
            })
            return filtered;

        }
        return result;
        
    },

    async getVariationImage(data) {
        const response = await fetch(APISettings.baseURL + "loggiaColors/v1/variation/" + data.id + "/" + data.color + "/" + data.size, {
            mode: 'cors',
            method: 'GET',
        });
        const result = await response.text();
        return result;
    },

    async getSizes(id) {
        const response = await fetch(APISettings.baseURL + "loggiaColors/v1/size/product/" + id, {
            mode: 'cors',
            method: 'GET',
        });
        const result = await response.json();
        let obj = [];
        result.forEach(e=>{
            obj.push({
                price : e.price,
                sizeFormValue : e.size,
                sizeLabel : e.size.replace("-",",").split("lt")[0]+"lt",
                sizeValue: e.size.replace("-",".").replace("lt","").replace("kg","")
            })
        })
        return obj;
    },

    async getPriceAndVideo(data) {
        const response = await fetch(APISettings.baseURL + "loggiaColors/v1/price/product/" + data.id + "/" + data.color + "/" + data.size, {
            mode: 'cors',
            method: 'GET',
        });
        const result = await response.json();
        return result;
    },

    async addToCart(data) {
        let nonce;

        const res = await fetch(APISettings.baseURL + "wc/store/cart/items");
        nonce = res.headers.get('Cart-Token');
        

        const response = await fetch(APISettings.baseURL +"wc/store/cart/add-item", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                'Cart-Token': nonce,
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data)
        })
        this.cartHash();
        return response.json();
    },

    async addManyToCart(data){
        let nonce;
        const res = await fetch(APISettings.baseURL + "wc/store/cart/items");
        nonce = res.headers.get('nonce');
        
        let obj = {
            requests:[]
        };
        data.forEach(element=>{
            obj.requests.push({
                path:"/wc/store/cart/add-item",
                method:"POST",
                cache:"no-store",
                body:element,
                headers:{"Nonce":nonce}
            })
        });
        const response = await fetch(APISettings.baseURL +"wc/store/batch", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(obj)
        })
        this.cartHash();
        return response.json();
    },

    async cartHash(){
        const responseHash = await fetch(window.location.origin+"/?wc-ajax=get_refreshed_fragments", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "no-cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        })
        const response = await responseHash.json();
        let icon = response.fragments[".cart-icon-link span"];
        let cartSide = response.fragments["#shopdock-ultra"];
        document.getElementById("shopdock-ultra").innerHTML = cartSide;
        document.getElementsByClassName("cart-icon-link")[1].innerHTML += icon;
        let keyStorage;
        for (let i = 0; i < localStorage.length; i++){
            let test = localStorage.key(i);
            if(test.includes("wc_cart_hash")){
                keyStorage = test;
            }
        }
        localStorage.setItem(keyStorage,response.cart_hash);
    }

}